/** Shopify CDN: Minification failed

Line 46:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 50:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 57:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 63:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:24 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 73:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 35:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 42:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 48:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:24 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 58:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 20:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 27:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 33:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:24 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 43:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
(async () => {
    const { Core } = await importModule('Core');
    const PREFIX_BUY_WITH = 'buy_with_' 

    customElements.define('product-form', class extends Core {

        elements = {
            formTargeter: '[data-product-form-targeter]',
            toCartButton: 'product-to-cart'
        }

        render() {
            if (!this.$formTargeter) return; 
            this.$form = this.$formTargeter.form;
            this.$form?.addEventListener('submit', this._submitHandler.bind(this));
        }

        _submitHandler(e) {
            e.preventDefault();
            this.$toCartButton.addToCart(this.cartItems, this.mainVariantId);
        }

        _isVariantInput([ inputName, value ]) {
            if (inputName === 'selling_plan') this._setSellingPlan(value);
            return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id';
        }
        
        _setSellingPlan(id) {
            this.sellingPlanId = id;
        }

        _setCartItem([ inputName, value ]) {
            if (inputName === 'id') this.mainVariantId = value;
            const sellingPlanId = this.sellingPlanId || '';
            return {
                id: value,
                quantity: this._getItemQty(inputName),
                selling_plan: inputName === 'id' ? sellingPlanId : '',
                properties: this._getProperties(inputName)
            }
        }

        _getItemQty(inputName) {
            return inputName === 'id' ? this.qty : 1;
        }
        _getProperties(inputName) {
            return inputName === 'id' ? this.properties : {};
        }

        get cartItems() {
            return Array.from(this.formData.entries())
                .filter(this._isVariantInput.bind(this))
                .map(this._setCartItem.bind(this))
        }

        get formData() {
            return new FormData(this.$form);
        }

        get qty() {
            return +this.formData.get('quantity') || 1;
        }
        get properties() {
            const propertyKeys = this.formData.getAll('customPropertyReference');
            return propertyKeys.reduce((acc, key) => {
                acc[key] = this.formData.get(`properties[${key}]`);
                return acc;
            }, {})
        }
    })
})();